import { Row, Col } from "antd";
import { useAuthContext } from "@/components/auth/AuthProvider";
import TypeChart from "./TypeChart";
import MonthChart from "./MonthChart";
import AccumulatorMonthChart from "./AccumulatorMonthChart"
import AnnouncementTable from "./AnnouncementTable";
import styles from "./index.module.less";

function AnnouncementStatistic() {
  const auth = useAuthContext();
  return (
    <div className={styles.annoStatistic}>
      <div className={styles.messStatistic}>
        <Row gutter={16}>
          <Col span={12}>
            <TypeChart token={auth?.token} />
          </Col>
          <Col span={12}>
            <MonthChart token={auth?.token} />
          </Col>
          <Col span={24}>
            <AccumulatorMonthChart token={auth?.token} />
          </Col>
          <Col span={24}>
            <AnnouncementTable />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default AnnouncementStatistic;
